import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-surface pt-20 pb-10 border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          <div className="col-span-1">
            <div className="brand-logo mb-6">
              <div className="shield-icon" style={{ transform: 'scale(0.7)', marginLeft: '-5px' }}>
                <span className="shield-char">F</span>
              </div>
              <div>
                <h1 className="font-serif font-bold text-lg text-crimson">FIT</h1>
                <p className="text-[8px] uppercase tracking-widest text-slate font-bold">Engineering College</p>
              </div>
            </div>
            <p className="text-xs text-gray-500 leading-relaxed pr-4">Empowering the next generation through innovation.</p>
          </div>
          <div>
            <h5 className="font-serif font-bold text-slate text-sm mb-4">Academics</h5>
            <ul className="space-y-3 text-sm text-gray-500">
              <li><a href="#" className="hover:text-crimson transition">Undergraduate</a></li>
              <li><a href="#" className="hover:text-crimson transition">Postgraduate</a></li>
              <li><a href="#" className="hover:text-crimson transition">PhD Programs</a></li>
            </ul>
          </div>
          <div>
            <h5 className="font-serif font-bold text-slate text-sm mb-4">Contact</h5>
            <ul className="space-y-3 text-sm text-gray-500">
              <li><a href="#" className="hover:text-crimson transition">admissions@fit.ac.in</a></li>
              <li><a href="#" className="hover:text-crimson transition">1800-FIT-EDU</a></li>
            </ul>
          </div>
          <div>
            <h5 className="font-serif font-bold text-slate text-sm mb-4">Social</h5>
            <div className="flex gap-4">
              <a href="#" className="w-8 h-8 rounded bg-white border border-gray-200 flex items-center justify-center text-slate hover:bg-crimson hover:text-white transition">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded bg-white border border-gray-200 flex items-center justify-center text-slate hover:bg-crimson hover:text-white transition">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-200 pt-8 text-center text-xs text-gray-400">
          &copy; 2025 FiT Engineering College. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;